import * as ss from 'superstruct';

export const UPSClientConfig = ss.type({
  accessLicenseNumber: ss.string(),
  username: ss.string(),
  password: ss.string(),
});

export type UPSClientConfig = ss.Infer<typeof UPSClientConfig>;
